<div
  id="default-page"
  class="inner-scroll"
  fxLayout="row"
  fxLayoutAlign="start">
  <div id="default-page-intro" fxFlex fxHide fxShow.gt-sm>
    <div class="title">
      <div
        class="title"
        [@animate]="{ value: '*', params: { delay: '50ms', y: '25px' } }">
        {{ 'GENERAL.TITLE.SITE' | translate }}
      </div>
      @for (message of maintenanceMessage; track message) {
        <div class="alert-message">
          @if (translationService.currentLang === 'fr') {
            <div class="row wrap">
              <div fxFlex="100">
                <div class="alert-message-title">
                  {{ message.titre_fr }}
                </div>
                {{ message.texte_fr }}
              </div>
            </div>
          }
          @if (translationService.currentLang === 'de') {
            <div class="row wrap">
              <div fxFlex="100">
                <div class="alert-message-title">
                  {{ message.titre_de }}
                </div>
                {{ message.texte_de }}
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
  <div
    id="default-page-form-wrapper"
    [@animate]="{ value: '*', params: { delay: '300ms', x: '100%' } }">
    <div id="default-page-form">
      <div class="logo">
        @if (translationService.currentLang !== 'de') {
          <img src="../../../assets/images/logos/logo_ent.svg" alt="Logo ENT" />
        }
        @if (translationService.currentLang !== 'fr') {
          <img
            src="../../../assets/images/logos/logo_ent_de.svg"
            alt="Logo ENT" />
        }
      </div>
      @if (canGetUser) {
        <div>
          <div fxlayout="row wrap" fxflex="50" class="default-page-student">
            <div class="title">{{ 'LOGIN.LOGINTITLE' | translate }}</div>
            <div class="title">{{ 'LOGIN.LOGINTITLEISM' | translate }}</div>
            <button
              (click)="login()"
              mat-raised-button
              color="accent"
              class="submit-button"
              aria-label="LOGIN"
              [disabled]="isBusy">
              {{ 'LOGIN.LOGIN' | translate }}
            </button>
            <mat-accordion
              #mobileMtncContainer
              class="maintenance-mobile-container">
              @for (message of maintenanceMessage; track message) {
                <mat-expansion-panel
                  (opened)="panelOpenState = true"
                  (closed)="panelOpenState = false">
                  <mat-expansion-panel-header>
                    @if (translationService.currentLang === 'fr') {
                      <mat-panel-title class="maintenance-title">
                        {{ message.titre_fr }}
                      </mat-panel-title>
                    }
                    @if (translationService.currentLang === 'de') {
                      <mat-panel-title class="maintenance-title">
                        {{ message.titre_de }}
                      </mat-panel-title>
                    }
                  </mat-expansion-panel-header>
                  <div class="alert-message">
                    @if (translationService.currentLang === 'fr') {
                      <div class="row wrap">
                        <div fxFlex="100">
                          {{ message.texte_fr }}
                        </div>
                      </div>
                    }
                    @if (translationService.currentLang === 'de') {
                      <div class="row wrap">
                        <div fxFlex="100">
                          {{ message.texte_de }}
                        </div>
                      </div>
                    }
                  </div>
                </mat-expansion-panel>
              }
            </mat-accordion>
            @if (isBusy) {
              <div fxLayout="row" fxLayoutAlign="center center">
                <mat-progress-spinner
                  [color]="spinner.color"
                  [mode]="spinner.mode"
                  [value]="spinner.value"
                  [diameter]="spinner.diameter">
                </mat-progress-spinner>
              </div>
            }
          </div>
          <mat-divider></mat-divider>
          <div class="default-page-teacher">
            <div class="title">{{ 'LOGIN.FIRSTACCESS' | translate }}</div>
            <button
              mat-raised-button
              color="warn"
              class="submit-button"
              aria-label="LOGIN"
              (click)="startActivation()"
              [disabled]="isBusy || isStartDisabled">
              {{ 'LOGIN.START' | translate }}
            </button>
            @if (isStartDisabled) {
              <mat-accordion #mobileMtncContainer>
                <mat-expansion-panel
                  (opened)="panelOpenState = true"
                  (closed)="panelOpenState = false">
                  <mat-expansion-panel-header>
                    <mat-panel-title class="maintenance-title">
                      {{ 'LOGIN.MAINTENANCE_START_TITLE' | translate }}
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="alert-message">
                    <div class="row wrap">
                      <div fxFlex="100">
                        {{ 'LOGIN.MAINTENANCE_START_CONTENT' | translate }}
                      </div>
                    </div>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            }
          </div>
        </div>
      }
      @if (!canGetUser) {
        <div>
          <div class="message-box error">
            <app-error-message [error]="error.error" />
          </div>
          <div class="logout-button">
            <button
              mat-raised-button
              color="warn"
              class="submit-button"
              (click)="logout()">
              <mat-icon class="icon-button">exit_to_app</mat-icon>
              <span class="title-button">Logout</span>
            </button>
          </div>
        </div>
      }
    </div>
  </div>
</div>
